module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiAQMAAAAAiZmBAAAABlBMVEXYFRf///8+enZLAAAAE0lEQVQI12MgBjD///9hgEliAADMlUC353n3AAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/jx.png
// module id = 448V
// module chunks = 1